import { render, staticRenderFns } from "./SignupPageWithTab.vue?vue&type=template&id=28a329e2&"
import script from "./SignupPageWithTab.vue?vue&type=script&lang=ts&"
export * from "./SignupPageWithTab.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports